import request from '../request'

//订单列表
export const getOrderList = data => {
  return request.post(`/wecom/order/list`, data)
}

export const getOrderDetailInWorkApi = orderNo => {
  return request.get(`/wecom/order/detail/${orderNo}`)
}

export const uploadPos = data => {
  return request.post(`/wecom/order/upload-pos`, data)
}

//订单发送状态
export const changeOrderApi = orderId => {
  return request.post(`/wecom/order/share/${orderId}`)
}
// 审批调价
export const auditAdjustPriceApi = data => {
  return request.post(`/wecom/order/audit-adjust-price`, data)
}
// 重新发起调价
export const reApplyAdjustPriceApi = data => {
  return request.post(`/wecom/order/apply-adjust-price`, data)
}

// 创建支付连接
export const createSelfPayUrl = data => {
  return request.post(`/wechat/order/create-self-pay-url`, data)
}

// 创建支付连接
export const resetDelivery = orderId => {
  return request.post(`/wecom/order/reset-delivery`, { orderId })
}

//搜索sku
export const searchSkusApi = sku => {
  return request.get(`/wecom/product/detail/${sku}`)
}
//搜索sku
export const searchSkySuggestApi = sku => {
  return request.get(`/wecom/product/search-suggestion/${sku}`)
}
//提交订单
export const submitOrderApi = data => {
  return request.post(`/wecom/order/submit-order`, data)
}

// 申请订单退款
export const applyRefund = data => {
  return request.post(`/wecom/order/refund-apply`, data)
}

// 订单发货
export const expressOrder = (orderId, urgent, insuranceAmount) => {
  return request.post(`/wecom/order/express`, {
    orderId,
    urgent,
    insuranceAmount
  })
}

// 取消订单发货
export const cancelExpress = orderId => {
  return request.post(`/wecom/order/cancel-express`, { orderId })
}

// 扫描面对面提货二维码
export const shipByQrCode = code => {
  return request.post(`/wecom/order/scan-qrcode/${code}`)
}

//销售端获取物流信息
export const getWxWorkRouteInfo = orderId => {
  return request.get(`/wecom/order/route-info/${orderId}`)
}
